type LanguageOption = {
  label: string
  value: string
}

type LanguageSelectorProps = {
  options: LanguageOption[]
  value: string
  onChange: (value: string) => void
}

export function LanguageSelector({
  onChange,
  options,
  value,
}: LanguageSelectorProps) {
  return (
    <fieldset className="m-0 flex flex-wrap items-center justify-center gap-6 border-0 p-0">
      <legend className="sr-only">Idioma</legend>
      {options.map((option) => {
        const checked = option.value === value

        return (
          <label className="inline-flex cursor-pointer items-center gap-2 text-text-primary" key={option.value}>
            <input
              checked={checked}
              className="peer pointer-events-none absolute opacity-0"
              name="language"
              onChange={() => onChange(option.value)}
              type="radio"
              value={option.value}
            />
            <span
              className={`inline-flex h-5 w-5 items-center justify-center rounded-full border transition-[border-color,background-color] duration-160 peer-focus-visible:ring-4 peer-focus-visible:ring-focus-ring ${
                checked
                  ? 'border-brand-primary'
                  : 'border-border-soft bg-surface-card'
              }`}
              aria-hidden="true"
            >
              <span
                className={`h-2 w-2 rounded-full transition-colors duration-160 ${
                  checked ? 'bg-brand-primary' : 'bg-transparent'
                }`}
              />
            </span>
            <span className="text-body-3">{option.label}</span>
          </label>
        )
      })}
    </fieldset>
  )
}
